import React, { useState, useEffect } from "react";
import { Box, Typography, IconButton, Paper } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import LocalActivityIcon from "@mui/icons-material/LocalActivity";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import { useTheme } from "@mui/material/styles";
import Creditors from "./Creditors";
import Costcenters from "./Costcenters";
import Payrollgroups from "./Payrollgroups";
import Allowances from "./Allowances";
import Qualifications from "./Qualifications";
import Certificates from "./Certificates";
import Schools from "./Schools";
import Competencies from "./Competencies";
import CertificateFields from "./CertificateFields";
import HealthFacilities from "./health-facilities";
import PayrollTypes from "./PayrollTypes";
import Employees from "./Employees";
import TempPayrolls from "./TempPayrolls";
import EmployeeExitHistory from "./EmployeeExitHistory";
import EntityPayrollApprovers from "./EntityPayrollApprovers";
import Sourceoffunds from "./Sourceoffunds";
import ForcedPayments from "./ForcedPayments";
import EmployeeRBMContracts from "./EmployeeRBMContracts";
import MoveUpIcon from "@mui/icons-material/MoveUp";
import EmployeeBonus from "./EmployeeBonus";
import UserRoles from "./UserRoles";
import ApplicantSession from "./ApplicantSession";
import WrittenExamDetails from "./WrittenExamDetails";
//import MappingGrobalPositions from "./MappingGrobalPositions";

function IppisSettings({ open, onClose }) {
  const theme = useTheme();

  const [activeMenu, setActiveMenu] = useState(null);
  const [activeItem, setActiveItem] = useState(null);

  const menuData = {
    recruitment: {
      title: "Recruitment",
      icon: <PeopleAltOutlinedIcon fontSize="small" />,
      items: ["Requisition", "Advertisement", "Written Exam","Applicant Session"],
    },
    RBM: {
      title: "RBM",
      icon: <MoveUpIcon fontSize="small" />,
      items: ["RBM Contract", "Employee Bonus"],
    },
    Exit: {
      title: "Exit",
      icon: <ExitToAppIcon fontSize="small" />,
      items: ["Exit requested"],
    },
    payroll: {
      title: "Payroll",
      icon: <PaymentsOutlinedIcon fontSize="small" />,
      items: [
        "Payrolls",
        "Employees",
        "Creditors",
        "CostCenters",
        "Payroll Groups",
        "Payroll Types",
        "Source of Funds",
        "Allowances",
        "Forced Payments",
      ],
    },
    user: {
      title: "IPPIS Users role",
      icon: <LocalActivityIcon fontSize="small" />,
      items: ["User Roles", "Payroll Approvers"],
    },
    common: {
      title: "Common",
      icon: <SettingsOutlinedIcon fontSize="small" />,
      items: [
        "Qualifications",
        "Competencies",
        "Certificate Fields",
        "Certificates",
        "Schools",
        "Health facilities",
        //"Mapping Grobal Positions",
      ],
    },
  };
  const handleClose = () => {
    setActiveMenu(null);
    setActiveItem(null);
    onClose?.();
  };

  const handleMenuClick = (key) => {
    setActiveMenu(activeMenu === key ? null : key);
    setActiveItem(null);
  };

  const handleItemClick = (item) => {
    setActiveItem(item);
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) handleClose();
  };

  useEffect(() => {
    const handleEscape = (e) => e.key === "Escape" && handleClose();
    if (open) {
      document.addEventListener("keydown", handleEscape);
      return () => document.removeEventListener("keydown", handleEscape);
    }
  }, [open]);
  if (!open) return null;
  return (
    <Box
      onClick={handleOverlayClick}
      sx={{
        position: "fixed",
        inset: 0,
        bgcolor: "rgba(0,0,0,0.6)",
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Paper
        elevation={4}
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        {/* Header */}
        <Box
          sx={{
            px: 3,
            py: 2,
            bgcolor: theme.palette.primary.light,
            color: theme.palette.primary.contrastText,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography sx={{ fontSize: "1.3rem", fontWeight: 600 }}>
            IPPIS Settings
          </Typography>
          <IconButton
            onClick={handleClose}
            sx={{ color: theme.palette.primary.contrastText }}
          >
            <CloseIcon />
          </IconButton>
        </Box>

        {/* Body */}
        <Box
          sx={{
            flex: 1,
            p: 2,
            bgcolor: "#f8f9fa",
            overflowY: "auto",
          }}
        >
          {/* Main Menu */}
          <Box sx={{ display: "flex", gap: 1, mb: 2, flexWrap: "wrap" }}>
            {Object.entries(menuData).map(([key, menu]) => (
              <Box
                key={key}
                component="button"
                onClick={() => handleMenuClick(key)}
                sx={{
                  flex: "1 1 140px",
                  p: "12px 14px",
                  borderRadius: "10px",
                  fontSize: "0.95rem",
                  fontWeight: 600,
                  border:
                    activeMenu === key
                      ? `2px solid ${theme.palette.primary.main}`
                      : "1px solid #e2e8f0",
                  bgcolor:
                    activeMenu === key ? theme.palette.primary.light : "#fff",
                  color:
                    activeMenu === key
                      ? theme.palette.primary.contrastText
                      : "#374151",
                  cursor: "pointer",
                  transition: "0.2s",
                  "&:hover": {
                    bgcolor: theme.palette.primary.light,
                    color: theme.palette.primary.contrastText,
                    borderColor: theme.palette.primary.main,
                  },
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 1,
                  }}
                >
                  {menu.icon}
                  <span>{menu.title}</span>
                </Box>
              </Box>
            ))}
          </Box>

          {/* Submenu */}
          {activeMenu && (
            <Paper
              elevation={1}
              sx={{
                p: 2,
                borderRadius: "10px",
                borderLeft: `5px solid ${theme.palette.primary.main}`,
              }}
            >
              <Typography
                sx={{
                  fontSize: "1rem",
                  fontWeight: 600,
                  color: theme.palette.primary.main,
                  mb: 1.5,
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                {menuData[activeMenu].icon}
                {menuData[activeMenu].title}
              </Typography>

              <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                {menuData[activeMenu].items.map((item) => (
                  <Box
                    key={item}
                    component="button"
                    onClick={() => handleItemClick(item)}
                    sx={{
                      p: "8px 14px",
                      fontSize: "0.9rem",
                      borderRadius: "6px",
                      border: "1px solid #e2e8f0",
                      bgcolor:
                        activeItem === item
                          ? theme.palette.primary.light
                          : "#fff",
                      color:
                        activeItem === item
                          ? theme.palette.primary.contrastText
                          : "#374151",
                      cursor: "pointer",
                      transition: "0.2s",
                      "&:hover": {
                        bgcolor: theme.palette.primary.light,
                        color: theme.palette.primary.contrastText,
                        borderColor: theme.palette.primary.main,
                      },
                    }}
                  >
                    {item}
                  </Box>
                ))}
              </Box>
            </Paper>
          )}

          {/* ✅ RENDER SELECTED CONTENT */}
          {activeItem === "Creditors" && (
            <Box sx={{ mt: 2 }}>
              <Creditors />
            </Box>
          )}

          {activeItem === "CostCenters" && (
            <Box sx={{ mt: 2 }}>
              <Costcenters />
            </Box>
          )}

          {activeItem === "Schools" && (
            <Box sx={{ mt: 2 }}>
              <Schools />
            </Box>
          )}
          {activeItem === "Payroll Groups" && (
            <Box sx={{ mt: 2 }}>
              <Payrollgroups />
            </Box>
          )}
          {activeItem === "Source of Funds" && (
            <Box sx={{ mt: 2 }}>
              <Sourceoffunds />
            </Box>
          )}
          {activeItem === "Certificate Fields" && (
            <Box sx={{ mt: 2 }}>
              <CertificateFields />
            </Box>
          )}
          {activeItem === "Employee Bonus" && (
            <Box sx={{ mt: 2 }}>
              <EmployeeBonus />
            </Box>
          )}
          {activeItem === "Allowances" && (
            <Box sx={{ mt: 2 }}>
              <Allowances />
            </Box>
          )}
          {activeItem === "Payroll Types" && (
            <Box sx={{ mt: 2 }}>
              <PayrollTypes />
            </Box>
          )}

          {activeItem === "Certificates" && (
            <Box sx={{ mt: 2 }}>
              <Certificates />
            </Box>
          )}

            {activeItem === "User Roles" && (
            <Box sx={{ mt: 2 }}>
              <UserRoles />
            </Box>
          )}

          {activeItem === "Payroll Approvers" && (
            <Box sx={{ mt: 2 }}>
              <EntityPayrollApprovers />
            </Box>
          )}

          {activeItem === "Employees" && (
            <Box sx={{ mt: 2 }}>
              <Employees />
            </Box>
          )}

          {activeItem === "Exit requested" && (
            <Box sx={{ mt: 2 }}>
              <EmployeeExitHistory />
            </Box>
          )}

          {activeItem === "Payrolls" && (
            <Box sx={{ mt: 2 }}>
              <TempPayrolls />
            </Box>
          )}

          {activeItem === "Competencies" && (
            <Box sx={{ mt: 2 }}>
              <Competencies />
            </Box>
          )}

          {activeItem === "Qualifications" && (
            <Box sx={{ mt: 2 }}>
              <Qualifications />
            </Box>
          )}
          {activeItem === "Forced Payments" && (
            <Box sx={{ mt: 2 }}>
              <ForcedPayments />
            </Box>
          )}

          {activeItem === "Health facilities" && (
            <Box sx={{ mt: 2 }}>
              <HealthFacilities />
            </Box>
          )}

          {activeItem === "RBM Contract" && (
            <Box sx={{ mt: 2 }}>
              <EmployeeRBMContracts />
            </Box>
          )}

            {activeItem === "Applicant Session" && (
            <Box sx={{ mt: 2 }}>
              <ApplicantSession />
            </Box>
          )}

            {activeItem === "Written Exam" && (
            <Box sx={{ mt: 2 }}>
              <WrittenExamDetails />
            </Box>
          )}

          {/* {activeItem === "Mapping Grobal Positions" && (
            <Box sx={{ mt: 2 }}>
              <MappingGrobalPositions />
            </Box>
          )} */}
          {/* Empty State */}
          {!activeMenu && (
            <Typography
              sx={{
                textAlign: "center",
                mt: 6,
                color: "#9ca3af",
                fontSize: "1rem",
              }}
            >
              Select a menu above to view options
            </Typography>
          )}
        </Box>
      </Paper>
    </Box>
  );
}

export default IppisSettings;
